<script>
    import { link } from "svelte-routing";
    import { getAuth, signInWithEmailAndPassword  } from "firebase/auth";
    import AuthError from "./AuthError.svelte";
    import CurrentPassword from "../passwords/CurrentPassword.svelte";
    import Input from "../Input.svelte";
    import Button from "../Button.svelte";
    import ButtonPrimary from "../ButtonPrimary.svelte";
    import PasswordRecoveryLink from "../passwords/PasswordRecoveryLink.svelte";

    const auth = getAuth();
    export let switchToSignUp;

    export let input = {
        email: "",
        password: ""
    }

    let errorCode;

    function login () {
        signInWithEmailAndPassword(auth, input.email, input.password)
        .then((userCredential) => {
            // Signed in 
            const user = userCredential.user;
            input.email= undefined;
            input.password = undefined;
            // ...
        })
        .catch((error) => {
            errorCode = error.code;
        });
    }

    function validate () {
        if (!input.email || !input.password) {
            return;
        }
        else {
            login();
        }
    }
</script>

<div class="form">
    <h1>Log In</h1>
    <form on:submit|preventDefault={validate}>
        <Input type="email" bind:value={input.email} autofocus={true}/>
        <Input type="password" bind:value={input.password}/>
        <div class="actions">
            <ButtonPrimary type="submit">Anmelden</ButtonPrimary>
            <PasswordRecoveryLink></PasswordRecoveryLink>
        </div>
    </form>
    <AuthError errorCode={errorCode}/>
    <!-- <hr>
    <Button on:click={switchToSignUp}>Noch keinen Account?</Button> -->
</div>

<style>
    .form {
        max-width: 30rem;
        margin: auto;
    }

    .actions {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
        margin-top: 2rem;
    }
</style>